import {ExpenseReportDao} from '../../dao';
import {

    ErrorModel
} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_EXPENSE_REPORT';

export async function createExpenseReport(
    userData: Record<string, string>,
    expense: Record<string, any>
) {
    try {
        const result = await ExpenseReportDao.createExpenseReport(userData.userToken, expense);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
